import React, { forwardRef, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { LinkProps } from './interfaces';

const Link = forwardRef<HTMLAnchorElement, PropsWithChildren<LinkProps>>(
  ({ children, className, to, href, ...rest }, ref) => {
    const baseClassName = classNames('link', className);

    const location = useLocation();

    if (to) {
      return (
        <RouterLink
          className={baseClassName}
          to={{ pathname: to }}
          state={{ prevPath: location?.pathname }}
          ref={ref}
        >
          {children}
        </RouterLink>
      );
    }

    return (
      <a className={baseClassName} href={href} ref={ref} {...rest}>
        {children}
      </a>
    );
  }
);

export default Link;
